import type { PublicationCode } from '@/scopes/common/domain/types';
import type { FiltersInQuickSearch } from '@/scopes/search/quick-search/domain/types';

// TODO check if we can unify this domain policy with the one in `scopes/search/search/domain/policies/publicationCodes.ts`
export function getDefaultFilterSelection(publicationCode: PublicationCode): Partial<FiltersInQuickSearch> {
  if (publicationCode === 'SZ') {
    return {
      Duration: ['8-11'],
      Participants: [{ adults: 2, children: [], babies: [] }],
    };
  }
  if (publicationCode === 'WG') {
    return {
      Duration: ['8-10'],
      Participants: [{ adults: 4, children: [], babies: [] }],
    };
  }
  if (publicationCode === 'KZ' || publicationCode === 'KW' || publicationCode === 'QZ' || publicationCode === 'QW') {
    return {
      Duration: ['8-8'],
      Participants: [{ adults: 2, children: [], babies: [] }],
    };
  }
  return {};
}
